import * as authHelper from './../../../../modules/auth/core/AuthHelpers';
import { ControlType, Property } from '../../../base/types';
import { IControlAttributes } from '../../../base/models';
import { Registry } from '../../../base/register';
import { useGetProperties } from '../../../base/hooks';
import { IFrameProperties } from './properties';
import clsx from 'clsx';
import { getBaseUrl } from '../../page-actions/url-helper';

export const IFrameComponent = (props: IControlAttributes) => {
  const { control } = props;
  const { token } = authHelper.getAuth() || {};
  const { properties } = useGetProperties({ bindings: control.bindings });
  const pageUrl: string | undefined = properties[Property.Url];

  if (!token || !pageUrl) {
    return (
      <p className="text-center text-muted">
        Unable to load content. Please ensure you are authenticated and a URL is provided.
      </p>
    );
  }

  const base64Token = btoa(token);

  return (
    <div className={clsx('container', 'my-3')}>
      <iframe
        src= {`${getBaseUrl(pageUrl)}/auth/token-auth(${encodeURIComponent(base64Token)})`}
        title="Dynamic IFrame"
        className="w-100 border-0"
        style={{ height: '500px' }}
      />
    </div>
  );
};

Registry.addControl({
  id: 'bcb0b6c8-5e16-4f01-b15e-e27965f8526e',
  name: 'IFrame',
  type: ControlType.IFrame,
  properties: IFrameProperties,
  component: IFrameComponent,
});
